export default __webpack_public_path__ + "static/media/default_project_thumbnail.21fcfcbc.jpg";